import { BlockStack, Icon, InlineStack, Modal, Text } from '@shopify/polaris'
import { StatusActiveMajor } from '@shopify/polaris-icons';
import { t } from 'i18next';
import React from 'react'

const CheckoutModal = (props: any) => {
    const { open, setOpen, choosePlan, plan, choosePlanLoading } = props;

    return (
        <Modal open={open?.active} onClose={() => setOpen(false)} title={t("You're One Step Away!")} primaryAction={{ content: t("Proceed to Checkout"), onAction: () => choosePlan(open?.plan_data?.plan_id, open?.plan_data?.code), loading: choosePlanLoading }} secondaryActions={[{ content: t("Change Plan"), onAction: () => setOpen(!open?.active) }]}>
            <Modal.Section>
                <BlockStack gap={"300"}>
                    <Text as='p' variant='bodyMd'>{t("You've chosen the perfect plan to fuel your Amazon success! Get ready to streamline your selling, boost visibility, and sell confidently.")}</Text>
                    <BlockStack gap={"150"}>
                        <Text as='p' variant='bodyMd' fontWeight='medium'>{t("Next Steps")}:</Text>
                        {["Review & Confirm Your Plan", "Complete the Payment", "Sell Smarter with CedCommerce"].map((ele, ind) => {
                            return (
                                <InlineStack gap={"100"} key={ind} align='start'>
                                    <span> <Icon source={StatusActiveMajor} tone='success' /></span>
                                    <Text as='p' variant='bodyMd'>{t(ele)}</Text>
                                </InlineStack>
                            )
                        })}
                    </BlockStack>
                </BlockStack>
            </Modal.Section>
        </Modal>
    )
}

export default CheckoutModal